import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import ReimbursementListTable from './ReimbursementListTable';
import { Button, Select, TextInput } from 'flowbite-react';
import { formatDateInputs } from '../../Utils';
import { BasicSearchRequest } from '../../Models/BasicSearchRequest';
import EditReimbursementModal from './EditReimbursementModal';
import { Reimbursement } from '../../Models/Reimbursement';
import ReimbursementApi from '../../Api/ReimbursementApi';

export default function ReimbursementList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [reimbursementListData, setreimbursementListData] = useState<
    Reimbursement[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showReimbursementInfo, setshowReimbursementInfo] =
    useState<boolean>(false);
  const [buttonDisabled, setbuttonDisabled] = useState<boolean>(false);
  const [selectedReimbursement, setselectedReimbursement] =
    useState<Reimbursement | null>(null);

  const [formData, setFormData] = useState<BasicSearchRequest>({
    status: 1,
    fromDate: new Date(new Date().setDate(new Date().getDate() - 14))
      .toISOString()
      .split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
  });

  useEffect(() => {
    getReimbursementList();
  }, []);

  const getReimbursementList = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return ReimbursementApi.getReimbursementList(formData)
          .then((res) => {
            setreimbursementListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            console.error(err);
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  const viewReimbursement = (obj: Reimbursement) => {
    setselectedReimbursement(obj);
    setshowReimbursementInfo(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    getReimbursementList();
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Reimbursement List</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='flex'>
          <div className=''>
            <form
              id='searchForm'
              onSubmit={onSubmit}
              className='flex gap-4 justify-center'
            >
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>Status:</div>
                <Select
                  id='status'
                  name='status'
                  onChange={handleChangeSelect}
                  value={formData.status ?? ''}
                  sizing='md'
                  required
                >
                  <option key={0} value={0}>
                    All
                  </option>
                  <option key={1} value={1}>
                    Pending
                  </option>
                  <option key={2} value={2}>
                    Paid
                  </option>
                  <option key={3} value={3}>
                    Canceled
                  </option>
                </Select>
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>From:</div>
                <TextInput
                  id='fromDate'
                  name='fromDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formatDateInputs(formData.fromDate ?? '')}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>To:</div>
                <TextInput
                  id='toDate'
                  name='toDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formatDateInputs(formData.toDate ?? '')}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <Button
                type='submit'
                form='searchForm'
                className='buttonMain'
                disabled={buttonDisabled}
              >
                Search
              </Button>
            </form>
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          {isLoading && <Loader />}
          <ReimbursementListTable
            data={reimbursementListData}
            viewReimbursement={viewReimbursement}
          />
        </div>
      </div>
      <EditReimbursementModal
        show={showReimbursementInfo}
        setShow={setshowReimbursementInfo}
        selectedReimbursement={selectedReimbursement}
        setselectedReimbursement={setselectedReimbursement}
        getReimbursementList={getReimbursementList}
      />
    </>
  );
}
